import initializeInputScripts from "./input";
import initializeSelectScripts from "./select";
import initializeMaskFields from "./masks";

const initializeFormsComponents = () => {
    initializeInputScripts();
    initializeSelectScripts();
    initializeMaskFields();
};

export default initializeFormsComponents;
